import React from 'react';
import Button from '@mui/material/Button';
import translate from '@/lib/intl/translate';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import AutomationsForm from './AutomationsForm';
import AutomationsList from './AutomationsList';
import AutomationsProvider, {
  useAutomationsContext,
} from './AutomationsProvider';

function BaseAutomationsPage() {
  const { createAutomation } = useAutomationsContext();
  return (
    <div className="p-4">
      <h2 className="mb-4 type-h2">{translate('AUTOMATIONS')}</h2>
      <p className="type-body1">{translate('AUTOMATIONS_DESCRIPTION')}</p>
      <Button
        className="mt-6 mb-8"
        onClick={createAutomation}
        variant="contained"
      >
        {translate('AUTOMATIONS_CREATE_NEW')}
      </Button>
      <AutomationsList />
      <AutomationsForm />
    </div>
  );
}

export default function AutomationsPage() {
  return (
    <AutomationsProvider>
      <BaseAutomationsPage />
    </AutomationsProvider>
  );
}
